import {
  Feature,
  FeatureFlagServiceInterface,
  FeatureFlag,
  Flag,
  FlagdFeatureFlagData,
} from './types/featureFlagTypes';
import { findFeatureValue, findFeatureVisibility } from './utils';

/**
 * * FeatureFlagService
 * @description Service to set feature flag and get its values
 *
 * * @function setFeatureFlagData
 *   @param Map<string, Feature>
 *   @description to set feature flag data
 * * @function getFeatureValue
 *   @returns Feature flag object
 *   @param key:string
 *   @description to get the feature flag object based on key
 * * @function getFeatureVisibility
 *   @param key:string
 *   @returns get the visibility value of feature true|false
 *   @description to visibility of feature based on key
 */
const FeatureFlagService: FeatureFlagServiceInterface = (function (root, factory) {
  let FeatureFlagService: FeatureFlagServiceInterface = {} as FeatureFlagServiceInterface;
  if (root) {
    // If instance exists use it otherwise create new.
    if (root.FeatureFlagService) {
      ({ FeatureFlagService } = root);
    } else {
      root.FeatureFlagService = FeatureFlagService;
      return factory(FeatureFlagService);
    }
  }

  return FeatureFlagService;
})(
  (typeof window === 'object' && window) || (typeof globalThis === 'object' && globalThis) || this,
  function (FeatureFlagService: FeatureFlagServiceInterface) {
    let featureDataObj: FeatureFlag = {};

    // Adding methods to Instance.
    FeatureFlagService.setFeatureFlagData = (featureData: FeatureFlag) => {
      featureDataObj = featureData;
    };
    FeatureFlagService.getFeatureValue = (key: string) => findFeatureValue(featureDataObj, key);
    FeatureFlagService.getFeatureVisibility = (key: string) => findFeatureVisibility(featureDataObj, key);

    return FeatureFlagService;
  },
);

export { FeatureFlagService };
export type { Feature, FeatureFlagServiceInterface, FeatureFlag, Flag, FlagdFeatureFlagData };
